'use client'

import { useReferencesProductFilters } from '@/feature/product/hooks/useReferencesProductFilters'
import { createOpenDiscriminantFiltersDrawerIntent } from '@/feature/product/services/product.intents'
import { referencesProductFiltersEnrichedAtom } from '@/feature/product/services/referencesProduct.store'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Button } from '@/ui/buttons/button/Button.client'
import { Icon } from '@/ui/icons/icon/Icon'
import { Skin } from '@/ui/skin/Skin'
import { useAtomValue } from 'jotai'
import { useState } from 'react'
import { ReferencesProductFiltersMobileDrawer } from './ReferencesProductFiltersMobileDrawer.client'

export function ReferencesProductFiltersMobile() {
  const { t } = useTranslation([
    'referencesProductFilters',
    'productListFilters',
    'productListFiltersProduct',
  ])
  const [isOpen, setIsOpen] = useState(false)

  const enrichedFilters = useAtomValue(referencesProductFiltersEnrichedAtom)

  const { totalActivesFilters } = useReferencesProductFilters()

  const openAll = () => setIsOpen(true)

  const openGroup = () => setIsOpen(true)

  const onClose = () => setIsOpen(false)

  return (
    <>
      <ReferencesProductFiltersMobileDrawer isOpen={isOpen} onCloseAction={onClose} />
      <Skin tint="body" className="py-2 desktop:hidden">
        <div className="flex flex-row flex-nowrap gap-1 overflow-auto scrollbar-none desktop:hidden">
          <Button
            size="md"
            variant={!totalActivesFilters ? 'secondary' : 'primary'}
            aria-label={t('productListFilters:openFilters')}
            iconLeft={!totalActivesFilters ? <Icon.ListFilter /> : <Icon.ListFilterPlus />}
            onPress={openAll}
            className="shrink-0"
            intent={createOpenDiscriminantFiltersDrawerIntent()}
          >
            {!totalActivesFilters
              ? t('productListFilters:filters')
              : t('productListFilters:activatedFilters')}
          </Button>

          {enrichedFilters.map((filter) => (
            <Button
              size="md"
              key={filter.label}
              variant="secondary"
              onPress={() => openGroup()}
              className="shrink-0"
              intent={createOpenDiscriminantFiltersDrawerIntent()}
            >
              {filter.label === t('productListFiltersProduct:sections.brand.title') &&
              t('productListFiltersProduct:sections.brand.accordionTitle')
                ? t('productListFiltersProduct:sections.brand.accordionTitle')
                : filter.label}
            </Button>
          ))}
        </div>
      </Skin>
    </>
  )
}
